import React, { useState } from 'react';
import Table from 'components/Table';
import { Pencil, Plus, Trash } from 'lucide-react';
import { Breadcrumb } from 'xland-ui';
import { useSelector, useDispatch } from 'react-redux';
import useDialog from 'components/Dialog/useDialog';
import { useCounter } from 'utils/customHooks';
import { deleteOrganizationAction } from 'modules/investmentAssets/actions';
import { fetchLocal } from 'components/Table/components/TableFunctions';
import { ROUTE_PATH } from 'routes';

import PopupEditOrganization from './PopupEditOrganization';
import PaymentSuccess from './PaymentSuccess';

function InvestorOrganizations() {
  const literals = useSelector(state => state.i18n.literals.investmentAssets);
  const literalsCommon = useSelector(state => state.i18n.literals.common);
  const tableRefreshFlag = useCounter(0);
  const user = useSelector(state => state.session.user);

  const [editOrganization, setEditOrganization] = useState(null);
  const dispatch = useDispatch();
  const { dialog } = useDialog();

  const fetchOrganizations = async (page, size, search, filters, sort) => {
    const data = { items: user.organizations, total: user.organizations.length };
    return fetchLocal(data, {}, page, size, search, filters, sort);
  };

  const handleDeleteOrganization = async (id) => {
    const response = await dialog({
      type: 'confirmDanger',
      text: literals.deleteOrganization,
    });

    if (response) {
      await dialog({
        type: 'loading',
        execute: async () => {
          await dispatch(deleteOrganizationAction(id));
          tableRefreshFlag.increase();
          return true;
        },
      });
    }
  };

  const columns = [
    {
      field: 'name',
      label: literalsCommon.name,
      preRender: (v, { members }) => (
        <div className='d-flex flex-column'>
          <span className='mb-2 fc-highest'>{v}</span>
          <span>{literals[`${members[user.email]}InvitedTo`]}</span>
        </div>
      ),
    },
    {
      type: 'menu',
      buttons: [
        {
          icon: <Pencil />,
          text: 'Edit',
          onClick: (v) => setEditOrganization(v),
          hidden: (_, row) => row.members[user.email] && row.members[user.email] < 2,
        },
        {
          icon: <Trash />,
          text: 'Delete',
          mode: 'danger',
          onClick: (row) => handleDeleteOrganization(row.id),
          hidden: (_, row) => row.members[user.email] && row.members[user.email] < 2,
        },
      ],
    },
  ];

  return (
    <>
      <Breadcrumb
        routes={[
          { name: literals.portfolio, path: ROUTE_PATH.INVESTOR_INVESTMENTS },
          { name: literals.myOrganizations },
        ]}
      />
      <Table
        columns={columns}
        forceFetch={tableRefreshFlag.value}
        fetch={fetchOrganizations}
        actions={[
          {
            icon: <Plus />,
            text: literalsCommon.addOrganization,
            onClick: () => setEditOrganization({ id: '', name: '', members: {} }),
          },
        ]}
      />
      <PaymentSuccess />
      {editOrganization && (
        <PopupEditOrganization
          organization={editOrganization}
          onClose={() => setEditOrganization(null)}
          onSave={() => tableRefreshFlag.increase()}
        />
      )}
    </>
  );
}

export default InvestorOrganizations;
